import { render, staticRenderFns } from "./MyMessageDetails.vue?vue&type=template&id=2a42d6ca&scoped=true&"
import script from "./MyMessageDetails.vue?vue&type=script&lang=js&"
export * from "./MyMessageDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyMessageDetails.vue?vue&type=style&index=0&id=2a42d6ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a42d6ca",
  null
  
)

export default component.exports